module.exports = __webpack_public_path__ + "static/media/logo-header.653bd0d7.png";